import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Stack } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useEffect, useState } from 'react'
import Header from "../../components/Header"
import { Outlet, Navigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Sidebar from '../../components/Sidebar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { selectUser } from '../../features/auth/authSlice';
import SearchBar from '../../components/Search';
import { getAllProjects, getAllZones, getAllActivities, getAllAdmins } from '../../features/db/data';
import NewProjectDialog from '../../components/NewProjectDialog';
import NewZoneDialog from '../../components/NewZoneDialog';
import NewReportDialog from '../../components/NewReportDialog';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

const BootstrapDialogTitle = (props) => {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

function ToggleShow(props)
{
	const {onChange = null} = props;
	const [state, setState] = useState(false);
	const texts = ["Show Inactive","Hide Inactive"];
	const variants = ["outlined","contained"];
	const onClick = (e) =>
	{
		if(onChange)
		{
			onChange(!state);
		}
		setState(!state);
	}

	return (
		<Button size="small" variant={variants[state?1:0]} onClick={onClick}>{texts[state?1:0]}</Button>
	)
}

export default function Home() {
	// add dialog
	const [dialogOpen, setDialogOpen] = useState(false)

	const handleDialogOpen = () => setDialogOpen(true)
	const handleDialogClose = () => setDialogOpen(false)

	// reports
	const [reports, setReports] = useState([])

	// zones
	const [zones, setZones] = useState([])

	// projects
	const [projects, setProjects] = useState([])

	const [admins, setAdmins] = useState([]);

	// get current user
	const user = useSelector(selectUser);
	const determinAdmin = ()=>
	{
		if(user)
		{
			if(admins.includes(user.uid))
			{
				return true;
			}
		}
		return false;
	}

	const isAdmin = determinAdmin();
	
	const [projectsFull, setProjectsFull] = useState([]);
	const [zonesFull   , setZonesFull]    = useState([]);
	const [reportsFull , setReportsFull]  = useState([]);

	let [gettingData,setGettingData] = useState(false)

	const getData = () => {
		if(!gettingData)
		{
			console.log("Loading data from firebase");
			gettingData = true;
			setGettingData(true);
			if(!(admins.length > 0))
			{
				console.log("\tgetting admins");
				getAllAdmins().then((temp) => { setAdmins(temp)});
			}else{
				console.log("\tskipping admins");
			}
			if(!(projectsFull.length > 0))
			{
				console.log("\tgetting projects");
				getAllProjects().then((temp) => { setProjectsFull(temp) });
			}else{
				console.log("\tskipping projects");
			}
			if(!(reportsFull.length > 0))
			{
				console.log("\tgetting reports");
				getAllActivities().then((temp) => { setReportsFull(temp) });
			}else{
				console.log("\tskipping reports");
			}
			if(!(zonesFull.length > 0))
			{
				console.log("\tgetting zones");
				getAllZones().then((temp) => { setZonesFull(temp) });
			}else{
				console.log("\tskipping zones");
			}
		}
	}
	
	useEffect(
		() => {
			getData();
		}, []
	);

	const [show,setShow] = useState(false);
	const onShowChange = (val) =>
	{
		setShow(val&&isAdmin);
		setProjects([]);
		setZones([]);
		setReports([]);
	}

	useEffect(
		() => {
			if(admins.length > 0)
			{
				if(!show)
				{
					if(projectsFull.length > 0)
					{
						if(!projects.length > 0)
						{
							let projTemp = projectsFull.filter(project=>{return project.status});
							setProjects(projTemp);
							console.log("projects filtered");
						}else{
							let projSet = new Set();
							projects.forEach(project=>{projSet.add(project.id)});
							if(zonesFull.length > 0 && !zones.length > 0)
							{
								setZones(zonesFull.filter(zone=>{return projSet.has(zone.project);}));
								console.log("zones filtered");
							}
							if(reportsFull.length > 0 && !reports.length > 0)
							{
								setReports(reportsFull.filter(report=>{return projSet.has(report.project);}));
								console.log("reports filtered");
							}
						}
					}
				}else{
					setProjects(projectsFull);
					setReports(reportsFull);
					setZones(zonesFull);
				}
			}
		}, [admins,projectsFull,zonesFull,reportsFull,projects,zones,reports]
	);

	// sidebar
	const [sidebar, setSidebar] = useState(true)

	// when click menu button
	const onClickMenu = () => {
		setSidebar(!sidebar);
	}

	const matches = useMediaQuery('(min-width:692px)');
	//const matches2 = useMediaQuery('(min-width:690px)');

	// search value
	const [searchValue, setSearchValue] = useState("");

	const submitProjectCallback = (p)=>
	{
		setProjectsFull([...projectsFull, p]);
		setProjects([]);
	}

	const submitZoneCallback = (p)=>
	{
		//console.log(p);
		setZones([]);
		if(p.length > 0)
		{
			setZonesFull([...zonesFull, ...p]);
			return;
		}
		setZonesFull([...zonesFull, p]);
	}

	return (
		!user ? <Navigate to="/" /> :
				<div>
					<Header title={matches?"ILALC File Management System":"IFMS"} menuFunc={onClickMenu} isAdmin={isAdmin} />
					<Box sx={{ display: "flex", p: 1, padding: "0px" }}>
						{/* project side bar */}
						{sidebar && matches ? <Box sx={{ minWidth: "20%" }}><Sidebar searchValue={searchValue} projects={projects} /></Box> : null}
						<Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
							<Box sx={{ flexShrink: 1, minWidth: "15%", height: "7vh", borderBottom: "1px inset", display: "flex", justifyContent: 'space-around', alignItems: "center" }}>
								<NewReportDialog projects={projects} zones={zones} variant="contained"/>
								{
									isAdmin ?
										<>
										<Button
											variant='outlined' startIcon={<AddIcon />} endIcon={<KeyboardArrowDownIcon />} size="small" color='primary'
											onClick={handleDialogOpen}
										>
											Add Project/Zone
										</Button>
										<ToggleShow onChange={onShowChange}/>
										</>
									:null
								}
								{matches&&sidebar?<SearchBar setSearchValue={setSearchValue}/>:null}
								<BootstrapDialog
									onClose={handleDialogClose}
									aria-labelledby="customized-dialog-title"
									open={dialogOpen}
								>
									<BootstrapDialogTitle id="customized-dialog-title" onClose={handleDialogClose} />
									<br />
									<DialogContent >
										<Box sx={{ display: "flex", flexDirection: "column", width: "300px" }} >
											<Stack spacing={{ xs: 1, sm: 2, md: 4 }}>
												<NewProjectDialog variant="outlined" submitCallback={submitProjectCallback}/>
												<NewZoneDialog variant="outlined" projects={projects} submitCallback={submitZoneCallback}/>
											</Stack>
										</Box>
									</DialogContent>
								</BootstrapDialog>
							</Box>
							<Box sx={{ height: "100%", padding: "10px" }}>
								<Outlet context={{ zones, reportsContainer:[reports,setReports], searchValue, isAdmin }} />
							</Box>
						</Box>
					</Box>
				</div>
	)
}

